define([],
function(ko) {
  return {
  }
});
